import { lazy } from "react";

const UserListPage = lazy(() => import("./main"));
const CreateUserPage = lazy(() => import("./create"));
const UpdateUserPage = lazy(() => import("./update"));
const UserReviewPage = lazy(() => import("./review"));
const CreateUserReview = lazy(() => import("./create-review"));

export {
  UserListPage,
  CreateUserPage,
  UpdateUserPage,
  UserReviewPage,
  CreateUserReview,
};
